/**
 * Guest Guard Component
 * Protects routes that should only be accessible to non-authenticated users
 * Redirects to dashboard if user is already authenticated
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { LoadingSpinner } from '../common/LoadingSpinner';

interface GuestGuardProps {
  children: React.ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Get the redirect URL from state (if user was redirected from a protected page)
  const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard';

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirect to dashboard (or previous page) if already authenticated
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}
